/**
 * @author       Pavlo Androshchuk
 * @copyright    Copyright (c) 2022, Zumper
 */

import React, { useCallback, useMemo } from 'react'
import { TRACK_USER_MENU_ACTION } from '../../../../constants'
import { usePathname } from '../../../../hooks/usePathname'
import { type ExtraNavLink, getAFRPetFriendlyMenuNavLinks } from '../../../../utils/getMenuNavLinks'
import { UserLinksSubmenu } from '../UserLinksSubmenu'

interface Props {
  onLinkClick: (name: string, href: string) => void
}

const EXTRA_LINKS = [
  {
    name: 'Near Me',
    href: '/near-me/pet-friendly-apartments',
    title: 'Pet-friendly Apartments Near Me',
    is_indexed: true,
    trackingName: TRACK_USER_MENU_ACTION.AFR_PET_FRIENDLY_NEAR_ME,
  },
] as const satisfies ReadonlyArray<ExtraNavLink>

export const AFRPetFriendlyUserSubmenu = ({ onLinkClick }: Props) => {
  const pathName = usePathname()
  const getLocaleLinkTitle = useCallback((name: string) => `Pet friendly ${name} apartments`, [])
  const links = useMemo(() => getAFRPetFriendlyMenuNavLinks(pathName), [pathName])
  return (
    <UserLinksSubmenu
      extraLinks={EXTRA_LINKS}
      getLocaleLinkTitle={getLocaleLinkTitle}
      links={links}
      onLinkClick={onLinkClick}
    />
  )
}
